<template>
  <nav class="navbar navbar-dark mb-3" style="background-color: #ff5700">
    <div class="container">
      <span class="navbar-brand"
        ><Router-link style="color: inherit" to="/"
          >Reddit View 🔍</Router-link
        ></span
      >
    </div>
  </nav>
  <div id="search-container" class="container">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {};
</script>

